import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Hashtag from "./Hashtag";
import Partners from "./Partners";
import styles from "./Header.module.scss";
import { useSelector } from "react-redux";
import hatIcon from "@public/images/icons/hat.png";
import bookIcon from "@public/images/icons/book.png";
import netIcon from "@public/images/icons/net.png";
import clsx from "clsx";

const Header: React.FC = () => {
  const currentTariff = useSelector((state: any) => state.Profile?.data.tariff);
  const authStatus = useSelector((state: any) => state.Auth.status);
  const [isAuth, setIsAuth] = useState(false);
  const [hasTariff, setHasTariff] = useState(false);

  useEffect(() => {
    if (currentTariff === null) {
      setHasTariff(false);
    } else {
      setHasTariff(true);
    }
  }, [currentTariff]);

  useEffect(() => {
    if (authStatus === "authorized") {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
  }, [authStatus]);

  return (
    <div className="w-full lg:min-h-[650px] md:h-calc-vh-full-70 flex flex-col justify-between m-auto bg-grey-f5">
      <header className="h-full">
        <div className={`cont ${styles.header}`}>
          <div
            className={clsx(
              "flex flex-col gap-6",
              "md:gap-10",
              "xl:gap-0 xl:flex-row xl:justify-between"
            )}
          >
            <div className="flex flex-col">
              <p
                className={clsx(
                  "font-bold text-sm pb-6 tracking-tighter-15 !leading-[130%]",
                  "md:text-2xl md:tracking-normal md:pb-10 md:!leading-[125%]",
                  "lg:text-32 md:!leading-[120%]",
                  "xl:text-36",
                  "2xl:pb-[60px]"
                )}
              >
                25 августа — 17 сентября
              </p>
              <h1
                className={clsx(
                  "font-bold !m-0 text-4xl pb-2 whitespace-nowrap !leading-[120%]",
                  "md:text-64 md:pb-5 md:!leading-[100%]",
                  "2xl:text-8xl 2xl:!leading-[90%]"
                )}
              >
                OTM: <br className="md:hidden xl:inline" /> WINTER 25/26
              </h1>
              <span className="text-sm md:text-lg xl:text-2xl !leading-[130%] md:!leading-[125%]">
                by{" "}
                <a
                  className="red-link"
                  target="_blank"
                  href="https://profi.travel"
                >
                  Profi.Travel
                </a>
              </span>
            </div>

            <div
              className={clsx(
                "flex flex-col gap-6 w-full justify-center",
                "md:gap-10",
                "xl:max-w-[471px]",
                "2xl:justify-start 2xl:pt-[115px]",
                "3xl:gap-[65px] 3xl:max-w-[566px] 3xl:pt-[90px]",
                "4xl:pt-[77px]"
              )}
            >
              <p className="text-sm md:text-lg xl:text-2xl !leading-[130%] md:!leading-[125%]">
                Онлайн-выставка актуальных зарубежных
                <br className="hidden md:inline" /> направлений для{" "}
                <span className="text-red-500">зимнего сезона 25/26</span>
              </p>

              {hasTariff && isAuth ? (
                <></>
              ) : (
                <Link
                  className="btn btn--reg h-[50px] md:h-[60px] text-18 md:text-24 w-full"
                  to={"?anchor=price-anchor"}
                >
                  Участвовать
                </Link>
              )}
            </div>
          </div>

          <div className="flex flex-col gap-[14px] justify-center items-center md:gap-6 md:flex-row lg:gap-8">
            <Hashtag
              text="вебинары"
              iconSrc={hatIcon}
              link="/?anchor=schedule-anchor"
              className="w-[154px] md:w-[183px] lg:w-[217px] 2xl:w-[287px]"
            />
            <Hashtag
              text="практикум"
              iconSrc={bookIcon}
              link="/?anchor=about"
              className="w-[154px] md:w-[186px] lg:w-[222px] 2xl:w-[294px]"
            />
            <Hashtag
              text="нетворкинг"
              iconSrc={netIcon}
              link="/networking"
              className="w-[154px] md:w-[195px] lg:w-[233px] 2xl:w-[311px]"
            />
          </div>
        </div>
      </header>
      <div className="w-full bg-white">
        <Partners />
      </div>
    </div>
  );
};

export default Header;
